module.exports = __webpack_public_path__ + "img/TaskFromQR1.eb81eab5.png";